import { VALAQUENTA_API_URL } from "../..";
import { authorizedAxios, loggingAxios } from "../../../App";
export function fetchFerryApiReservations({ params }) {
  return authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/api-ferry/`,
    { params }
  );
}

export async function retrieveFerryApiReservation({ reference }) {
  return await authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/api-ferry/${reference}/`
  );
}
export async function patchFerryApiReservation({ reference, payload }) {
  return await loggingAxios.patch(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/api-ferry/${reference}/`,
    payload
  );
}
export function getFerryApiReservationStats({ params }) {
  return authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/api-ferry/stats/`,
    { params }
  );
}
